import { get } from 'lodash'
import { required, requiredPhone, email, phone, requiredFutureDate } from 'utils/validation'

export const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  if (!get(values, 'email')) {
    return new Promise(resolve => resolve())
  }

  return props.onCheckEmail({ email: get(values, 'email') }).then(body => {
    if (get(body, 'value')) {
      // eslint-disable-next-line
      throw {
        email: {
          text: 'E-mail address is already in use.',
          intlKey: 'errors.email_address_is_in_use'
        }
      }
    }
  })
}

export const validate = values => {
  const isExempted = get(values, 'isExempted')

  const isApplyCPNNeeded = get(values, 'isApplyCPNNeeded')

  const showWWCDetails = !(isExempted || isApplyCPNNeeded)


  let errors = {
    email: required(get(values, 'email')) || email(get(values, 'email')),
    secondaryEmail: email(get(values, 'secondaryEmail')),
    tertiaryEmail: email(get(values, 'tertiaryEmail')),
    phoneNumber:
      requiredPhone(get(values, 'phoneNumber')) ||
      phone(get(values, 'phoneNumber')),
    phoneType: {
      value: required(get(values, 'phoneType.value'))
    },
    emailAgain: required(get(values, 'emailAgain')),
    childProtectionNumber: showWWCDetails && required(get(values, 'childProtectionNumber')),
    childProtectionExpirationDate: showWWCDetails && requiredFutureDate(
      get(values, 'childProtectionExpirationDate')
    ),
    exemptionReason: !isApplyCPNNeeded && isExempted && required(get(values, 'exemptionReason'))
  }

  return errors
}
